import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
// import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
// import { ApolloLink } from 'apollo-link';
import { useAuthToken, eraseCookie, getCookie } from '../token';
import { shuffleToken } from '../authorization';
import { onError } from '@apollo/client/link/error';

// just in case we need to upload files to our servers
const link = createUploadLink({ uri: process.env.REACT_APP_GRAPHQL_API });

// this will append our token  on every request
const authMiddleware = new ApolloLink((operation, forward) => {
  const authToken = getCookie();
  if (authToken) {
    operation.setContext(({ headers = {} }) => {
      if (headers.Authorization || headers.authorization) {
        return { headers };
      }
      return {
        headers: {
          ...headers,
          authorization: `Bearer ${shuffleToken(authToken)}`
        }
      };
    });
  }
  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      if (
        extensions?.code === 'UNAUTHENTICATED' &&
        operation.operationName !== 'loginUser'
      ) {
        console.error('Authentication error - redirecting to login');
        // const [, , eraseCookie] = useAuthToken();
        eraseCookie();
        window.location.href = '/login';
      }
    });
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
    if (networkError.statusCode === 401) {
      // const [, , eraseCookie] = useAuthToken();
      eraseCookie();
      window.location.href = '/login';
    }
  }
});

const cache = new InMemoryCache({
  addTypename: false
});

const useAppApolloClient = () => {
  // const [authToken] = useAuthToken();
  return new ApolloClient({
    link: errorLink.concat(authMiddleware).concat(link),
    cache
  });
};
export default useAppApolloClient;
